import { render, staticRenderFns } from "./NavbarType.vue?vue&type=template&id=5a4abc3e&"
import script from "./NavbarType.vue?vue&type=script&lang=js&"
export * from "./NavbarType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports